import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { APP_PATH_CANDIDATE_PROFILE } from '../../config';

const useStyle = makeStyles((theme) => ({
  userName: {
    marginBottom: '10px',
    marginTop: '10px',
    textAlign: 'center',
    color: theme.palette.text.primary,
    transition: 'all 0.3s ease'
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    transition: 'transform 0.3s ease',
    backgroundColor: theme.palette.secondary.main,
    fontSize: '1.5rem',
    fontWeight: 600
  },
  userInfoCard: {
    cursor: 'pointer',
    padding: theme.spacing(1),
    '&:hover': {
      '& $avatar': {
        transform: 'scale(1.1)'
      },
      '& $userName': {
        color: theme.palette.text.primary,
        opacity: 0.9
      }
    }
  }
}));

const UserInfo = ({ user, history, fileLogoUrl }) => {
  const classes = useStyle();

  // Get user initials for avatar
  const getUserInitials = (fullName) => {
    if (!fullName) return '?';
    const names = fullName.trim().split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    return fullName[0].toUpperCase();
  };

  const displayName =
    user?.fullName || user?.full_name || user?.email || 'User';

  return (
    <Grid
      className={classes.userInfoCard}
      onClick={() => {
        history.push(APP_PATH_CANDIDATE_PROFILE);
      }}
      alignItems="center"
      container
      direction="column"
      justifyContent="flex-start">
      <Grid item>
        <Avatar className={classes.avatar} src={fileLogoUrl || ''}>
          {!fileLogoUrl && getUserInitials(displayName)}
        </Avatar>
      </Grid>
      <Grid item>
        <Typography className={classes.userName} variant="h4">
          {displayName}
        </Typography>
      </Grid>
    </Grid>
  );
};

UserInfo.propTypes = {
  user: PropTypes.object,
  fileLogoUrl: PropTypes.string,
  history: PropTypes.object.isRequired
};

export default withRouter(UserInfo);
